<sm-title-bar [pageTitle]="pageTitle" [back]="true" > </sm-title-bar>
<mat-card >
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table-for-appointments [columnHeaders]="tableDisplayColumns" [dataSource]="customerBookingData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="true" [itemsPerPage]="25"        [rowClickHandler]="rowClickHandler">
      </sm-data-table-for-appointments>
    </div>
  </mat-card>
  

  
  <ng-template #menuTemplate let-rowvalue>
    
    <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>{{ 'customer_all_bookings.op1' | translate }}</span>
    </button>
    <!-- <button mat-menu-item (click)="openInvoice(rowvalue)" *ngIf="rowvalue.current_status == 4">
      <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
      <span>{{ 'customer_all_bookings.op2' | translate }}</span>
    </button> -->
  </ng-template>
  <!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->